import type { ResourceResponse, ID } from "types";
import { useFileUpload } from "hooks";
import { ApiRoutes } from "consts/enpoints/api";
import BusinessLogicException from "exceptions/BusinessLogicException";

type Filable = File | string | undefined | null;

export const useOnboardingFileUpload = () => {
    const uploadFile = useFileUpload();

    return ({ resource, identifier }: {
        readonly resource: string;
        readonly identifier?: ID;
    }, ...args: Array<[Filable, string]>) => (
        Promise.all(args.map(([file, field]) => (
            uploadFile({
                url: ApiRoutes.PostOnboardingsFiles(),
                files: [
                    {
                        field,
                        resource,
                        identifier,
                        file: assertFile(file)
                    }
                ]
            })
        ))).then((responses: Array<ResourceResponse<unknown>>) => {
            for (const response of responses) {
                if (!response.success) {
                    throw response;
                }
            }
        })
    );
};

export default useOnboardingFileUpload;

function assertFile(file: Filable): File {
    if (!(file instanceof File)) {
        throw new BusinessLogicException(
            'File must be a File instance',
            { file }
        );
    }

    return file;
}
